import React, { useState } from "react";
import { HorizontalLine } from "@design-system/HorizontalLine/HorizontalLine";
import { Separator } from "@design-system/Separator/Separator";
import { BooleanControl, SelectControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

const orientations = ["horizontal", "vertical"] as const;
type SeparatorOrientation = (typeof orientations)[number];

const sectionLabel = "or";

export const DividersPlayground = () => {
    const [orientation, setOrientation] =
        useState<SeparatorOrientation>("horizontal");
    const [isDecorative, setIsDecorative] = useState(false);
    const [isBlock, setIsBlock] = useState(true);
    const [hasLabel, setHasLabel] = useState(true);

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Separator</h2>
                        <div className={styles.fields}>
                            <SelectControl
                                label="Orientation"
                                options={orientations}
                                value={orientation}
                                onChange={setOrientation}
                            />
                        </div>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Decorative"
                                checked={isDecorative}
                                onChange={setIsDecorative}
                            />
                            <BooleanControl
                                label="Block"
                                checked={isBlock}
                                onChange={setIsBlock}
                            />
                        </div>
                    </section>
                    <section>
                        <h2>HorizontalLine</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Label"
                                checked={hasLabel}
                                onChange={setHasLabel}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={`Separator ${orientation}`}
                width="wide"
                output={JSON.stringify(
                    {
                        componentProps: {
                            separator: {
                                orientation,
                                decorative: isDecorative,
                                block: isBlock,
                            },
                            horizontalLine: {
                                children: hasLabel ? sectionLabel : null,
                            },
                        },
                        showcaseState: { hasLabel },
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.dividerShowcase}>
                    <div className={styles.surface}>
                        <div className={styles.dividerStack}>
                            <div className={styles.dividerBlock}>
                                Reconciled transactions
                            </div>
                            <HorizontalLine>
                                {hasLabel ? sectionLabel : undefined}
                            </HorizontalLine>
                            <div className={styles.dividerBlock}>
                                Transactions to review
                            </div>
                        </div>
                    </div>
                    <div className={styles.surface}>
                        <div
                            className={
                                orientation === "vertical"
                                    ? styles.verticalDividerRow
                                    : styles.dividerStack
                            }
                        >
                            <div className={styles.dividerBlock}>Cash in</div>
                            <Separator
                                orientation={orientation}
                                decorative={isDecorative}
                                block={isBlock}
                            />
                            <div className={styles.dividerBlock}>Cash out</div>
                        </div>
                    </div>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
